import { useEffect } from 'react';

import { PricingSection } from '@/components/organisms';
import { AnalyticsEvent, trackEvent } from '@/lib/analytics';

export function PricingPage() {
  useEffect(() => {
    trackEvent(AnalyticsEvent.PricingPageViewed);
  }, []);

  return <PricingSection />;
}
